import DeleteImg from 'assets/img/delete_img.png';
import { useDeleteBOCompany } from 'components/backoffice/company/hooks/useCompanyMutation';
import { useDeleteBoard } from 'components/board/api/useBoard';
import { useDeleteProcess } from 'components/businessProcess/api/useProcess';
import { useUpdateEmployee } from 'components/organizations/employees/api/useEmployee';
import { Hooks } from 'providers';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  HIT_UPDATE_STRUCTURE,
} from 'redux/actions/organization';
import title from './title';

function DeleteBoard(props) {
  const { isFocusPosition, idFocus, data } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    modalDelete,
    setModalDelete,
    setModal,
    boardNow,
    text: textPopUp,
  } = useContext(Hooks);
  const [text, setText] = useState('');
  const { mutate: deleteBOCompany } = useDeleteBOCompany();
  const { mutate: deleteEmployee } = useUpdateEmployee();
  const { mutate: deleteBoard } = useDeleteBoard();
  const { mutate: deleteProcess } = useDeleteProcess();

  const DeleteBoard__ = () => {
    if (props.for === 'bo-company') {
      const payloadDelete = {
        company_id: props.id,
      };
      deleteBOCompany(payloadDelete);
    } else if (props.for === 'bussines-process') {
      const payloadDelete = {
        process_id: props.id,
      };
      deleteProcess(payloadDelete);
    } else if (props?.for === 'structure_view') {
      dispatch({
        type: HIT_UPDATE_STRUCTURE,
        payload: {
          data: props.data,
          board_id: localStorage.getItem('board_id'),
          isFocusPosition,
          idFocus,
        },
      });
    } else if (props?.for === 'list_employee') {
      const payloadDelete = data;

      deleteEmployee(payloadDelete);
    } else {
      const payloadDelete = {
        board_id: boardNow,
      };

      deleteBoard(payloadDelete);
    }

    setModalDelete(false);
    setModal(false);
  };
  useEffect(() => {
    if (props.for === 'bo-company') {
      setText(t('general.message.del_company_message'));
    } else if (props.for === 'board') {
      setText(t('general.message.del_board_message'));
    } else if (props.for === 'bussines-process') {
      setText(t('general.message.del_bp_message'));
    } else if (props.for === 'structure_view') {
      setText(t('general.message.del_structure_message'));
    } else if (props.for === 'list_employee') {
      setText(t('general.message.del_employee_message'));
    } else {
      setText(
        'WARNING! This action cannot be reverted, it will delete your boardAA and all of the data inside the board, do you wish to continue?',
      );
    }
  }, [t]);

  const isOpen = Boolean(modalDelete && !textPopUp.company_id);

  return (
    <div
      className={`modal fade rModal ${isOpen ? 'show' : ''}`}
      id="deleteModal"
      tabIndex={-1}
      role="dialog"
      aria-hidden={!isOpen}
    >
      <div className="modal-dialog modal-sm" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title({ data: props.for, t })}</h5>
            <button
              id="delete-button-close"
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setModalDelete(false);
                setModal(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body m-3">
            <img src={DeleteImg} className="rModalImg" />
            <p className="mb-0">{text}</p>
          </div>
          <div className="modal-footer">
            <button
              id="delete-button-cancel"
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={() => {
                setModalDelete(false);
                setModal(false);
              }}
            >
              {t('biz_process.cancel')}
            </button>
            <button
              id="delete-button-continue"
              onClick={() => {
                DeleteBoard__();
              }}
              type="button"
              data-dismiss="modal"
              className="btn btn-primary"
            >
              {t('workload_landing.continue')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteBoard;
